import { CheckTextSelect } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperData = ["内容入力", "機構へ提出"];
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "共済契約者名",
    keyword: "contractorName",
    requiredIcon: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    requiredIcon: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    maxDate: new Date(),
    requiredIcon: true,
  },
  {
    title: "確認する書類の選択",
    keyword: "documentSelection",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    requiredIcon: true,
  },
  {
    title: "個人番号を確認する書類",
    keyword: "personalNumberVerification",
    type: "fileUpload",
    id: "1",
    requiredIcon: true,
    showLine: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "documentConfirmation",
    type: "fileUpload",
    id: "2",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "documentConfirmation2",
    type: "fileUpload",
    id: "3",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "documentConfirmationFront",
    type: "fileUpload",
    id: "4",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "documentConfirmationBack",
    type: "fileUpload",
    id: "5",
    requiredIcon: true,
    showLine: false,
  },
];

const schema = {
  contractorName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
  facilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
  staffName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
  },
  staffBirthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0049E"),
  },
  documentSelection: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  personalNumberVerification: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const showFakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者名",
    keyword: "contractorName",
    type: "text",
  },
  {
    title: "契約者住所",
    keyword: "contractoraddress",
    type: "text",
  },
  {
    title: "施設名",
    keyword: "facilityName",
    type: "text",
  },
  {
    title: "職員名",
    keyword: "staffName",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "staffBirthday",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "staffperiod",
    type: "text",
  },
];

export { stepperData, fakeTableList, schema, showFakeTableList };
